if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.submitButton = this.querySelector('[type="submit"]');
        this.stickyButton = document.querySelector(
          "sticky-bar .js-product-add"
        );
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("disabled", true);
        this.submitButton.classList.add("loading");

        if (this.stickyButton) {
          this.stickyButton.setAttribute("disabled", true);
          this.stickyButton.classList.add("loading");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;

        const giftItems = this.addFreeProducts();

        const itemsToAdd = [];
        const additions = document.querySelectorAll(".js-product-addition");
        if (additions.length) {
          additions.forEach((addition) => {
            if (addition.checked) {
              itemsToAdd.push({
                id: addition.value,
                quantity: 1,
              });
            }
          });
        }

        if (giftItems) {
          giftItems.forEach((gift) => {
            itemsToAdd.push({
              id: gift,
              quantity: 1,
              properties: {
                "_free_product": true
              }
            });
          });
        }

        if (itemsToAdd.length) {
          fetch(`${routes.cart_add_url}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: itemsToAdd,
            }),
          }).then(() => {
            this.addMainProduct(config);
          });
        } else {
          this.addMainProduct(config);
        }
      }

      addFreeProducts() {
        const giftsInput = this.querySelector('.js-gifts');
        if (!giftsInput) return;

        const gifts = giftsInput.value.split(',').map((gift) => {
          return gift;
        });

        return gifts;
      }

      addMainProduct(config) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartAdd);
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("disabled");

            if (this.stickyButton) {
              this.stickyButton.classList.remove("loading");
              this.stickyButton.removeAttribute("disabled");
            }
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");

            if (this.stickyButton) {
              this.stickyButton.classList.remove("loading");
            }

            if (!this.error) {
              this.submitButton.removeAttribute("disabled");
              if (this.stickyButton) {
                this.stickyButton.removeAttribute("disabled");
              }
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, null, false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, null, true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );

    let discountDifference = this.currentVariant.compare_at_price - this.currentVariant.price;
    let percentageDiscount = Math.floor(discountDifference / this.currentVariant.compare_at_price * 100);

    const variantChangeEvent = new CustomEvent('variant:change', {
      detail: {
        price: this.currentVariant.price,
        compare_at_price: this.currentVariant.compare_at_price,
        percentage_discount: percentageDiscount,
      },
    });
    document.dispatchEvent(variantChangeEvent);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const backgroundSource = html.getElementById(
          `MainProduct-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const backgroundDestination = document.getElementById(
          `MainProduct-${this.dataset.section}`
        );
        const destination = document.querySelectorAll(".js-product-price");
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const labelSource = html.getElementById(
          `ProductLabel-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const labelDestination = document.querySelectorAll(".js-product-tag");

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        const variantMediaDestination = document.getElementById(
          `product-media-section-${this.dataset.section}`
        );

        const variantMediaSource = html.getElementById(
          `product-media-section-${this.dataset.section}`
        );
        const preorderMessageSource = html.querySelector(
          ".product-form__message"
        );

// Get the delivery block for the newly selected variant.
const deliverySource = html.querySelector(
  ".product-info-box--delivery"
);

const deliveryDestination = document.querySelector(
  ".product-info-box--delivery"
);

        const preorderMessageDestination = document.querySelector(
          ".product-form__message"
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination.length) {
          destination.forEach((el) => {
            el.innerHTML = source.innerHTML;
          });
        }
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;

        if (labelSource && labelDestination.length) {
          labelDestination.forEach(destination => {
            destination.innerHTML = labelSource.innerHTML;
          });
        }

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        // Update the delivery message when the selected variant changes.
if (deliverySource && deliveryDestination) {
  deliveryDestination.innerHTML = deliverySource.innerHTML;

  deliveryDestination.className = deliverySource.className;

  // Reinitialise the delivery countdown for in-stock variants.
  const deliveryEstimate = deliveryDestination.querySelector(
    "delivery-estimation"
  );

  if (deliveryEstimate) {
    const newEstimate = deliveryEstimate.cloneNode(true);
    deliveryEstimate.replaceWith(newEstimate);
  }
}

        if (preorderMessageSource && preorderMessageDestination) {
          preorderMessageDestination.innerHTML =
            preorderMessageSource.innerHTML;
          preorderMessageDestination.classList.remove("hidden");
        } else if (preorderMessageDestination) {
          preorderMessageDestination.classList.add("hidden");
        } else if (preorderMessageSource) {
          const newNode = document.createElement("div");
          newNode.classList.add("product-form__message");
          newNode.innerHTML = preorderMessageSource.innerHTML;

          const form = document.querySelector(".product__form-container form");
          form.insertBefore(
            newNode,
            document.querySelector(".product-form__actions")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const maxQuantityUpdated = html.querySelector(
          `.product-form__buttons .quantity__input`
        );
        const quantityInput = document.querySelector(
          `.product-form__buttons .quantity__input`
        );
        if (maxQuantityUpdated && quantityInput) {
          quantityInput.max = maxQuantityUpdated.max;
        }

        const addButtonUpdated = html.querySelector(".product-form__submit");
        const addButtonText = addButtonUpdated
          ? addButtonUpdated.querySelector("span:not(.loader)")?.innerHTML
          : null;

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          addButtonText
        );

        if (variantMediaDestination && variantMediaSource) {
          variantMediaDestination.innerHTML = variantMediaSource.innerHTML;
        }

        if (backgroundSource && backgroundDestination) {
          backgroundDestination.style.background = backgroundSource.style.background;
        }

        enableZoomOnHover(2);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const formId = `product-form-${this.dataset.section}`;
    const addButtons = document.querySelectorAll(
      `[name="add"][form="${formId}"], #${formId} [name="add"]`
    );
    if (!addButtons.length) return;

    addButtons.forEach((addButton) => {
      const addButtonText = addButton.querySelector("span:not(.loader)");
      if (!addButtonText) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        if (text) {
          addButtonText.innerHTML = text;
        } else {
          addButtonText.textContent = window.variantStrings.addToBag;
        }
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const formId = `product-form-${this.dataset.section}`;
    const addButtons = document.querySelectorAll(
      `[name="add"][form="${formId}"], #${formId} [name="add"]`
    );
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    addButtons.forEach((addButton) => {
      const addButtonText = addButton.querySelector("span:not(.loader)");
      if (!addButtonText) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      addButton.setAttribute("disabled", "disabled");
    });

    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);
